import { message, Tooltip } from 'antd';
import classNames from 'classnames';
import React, { useState } from 'react';
import { StopListItem } from '../../../utils/formatType';
import TipMessage from './TipMessage';
import _ from 'lodash';
import {
  homePoint,
  stopPointArrived,
  stopPointCurrent,
  stopPointUnArrived,
  lastPointArrived,
  lastPointUnArrived,
} from '../Icon';
import qs from 'qs';
import { api } from '../../../fetch/bussiness/api';
import { request } from '../../../fetch/core';
import Time from './time';
import ContinueTime from './continueTime';
import ScheduleModel from '../../ScheduleModel/SchedulemModel';
import { getPermissionById } from '@/utils';
import { PermissionButton } from '@/utils/constant';
interface Props extends StopListItem {
  currentIndex: number;
  taskType: string;
  stopList: StopListItem[];
  readonly?: boolean;
}
const dotTypeImg = new Map([
  ['START', [homePoint, homePoint, '']],
  ['LOAD', [stopPointCurrent, stopPointArrived, stopPointUnArrived]],
  ['PICKUP', [stopPointCurrent, stopPointArrived, stopPointUnArrived]],
  ['DROPOFF', [stopPointCurrent, stopPointArrived, stopPointUnArrived]],
  ['UNLOAD', [stopPointCurrent, stopPointArrived, stopPointUnArrived]],
  ['RETURN', [lastPointArrived, '', lastPointUnArrived]],
]);
const StopPoint = (props: Props) => {
  const {
    id,
    title,
    time,
    percent,
    stopStatus,
    arrivedTime,
    travelStatus,
    waitingTime,
    stopAction,
    goalId,
    currentIndex,
    taskType,
    estDepartTime,
    stopList,
    globalMileage,
    readonly,
  } = props;

  const query = qs.parse(window.location.search.split('?')[1]);
  const license = query && query.license;
  const [hoverItem, setHoverItem] = useState<any>({});
  const [visible, setVisible] = useState(false);

  /**
   * 调度停靠点信息
   */
  const getScheduleStopState = async () => {
    const requestParam: RequestOptions = {
      method: 'POST',
      path: api.getScheduleStopState,
      body: {
        stopId: id,
        goalId: goalId,
        stopAction: stopAction,
        vehicleName: license,
      },
    };
    const res: any = await request(requestParam);
    if (res.code == 0) {
      const { data } = res;
      if (data) {
        const newItem = {
          ...props,
          totalDeliveryOrderNum: data.totalDeliveryOrderNum,
          totalCollectOrderNum: data.totalCollectOrderNum,
          finishedDeliveryOrderNum: data.finishedDeliveryOrderNum,
          finishedCollectOrderNum: data.finishedCollectOrderNum,
          canceledCollectOrderNum: data.canceledCollectOrderNum,
          canceledDeliveryOrderNum: data.canceledDeliveryOrderNum,
        };
        setHoverItem(newItem);
      }
    } else {
      message.error(res.message || '接口请求报错');
    }
  };

  // 兼容跳点情况
  const newStopListReverse = _.cloneDeep(stopList);
  const findDepartTime = newStopListReverse.reverse().find((item: any) => {
    return item.travelStatus === 'DEPART';
  });

  return (
    <>
      <li
        className={classNames('item', {
          finished: travelStatus === 'DEPART',
          staying: travelStatus === 'STAY',
          incomplete: travelStatus === 'START',
          init: travelStatus === 'INIT',
        })}
        style={{
          width: stopList.length < 8 ? `${100 / stopList.length}%` : '145px',
        }}
      >
        <Tooltip
          title={
            !['INIT', 'START'].includes(travelStatus) &&
            !readonly && (
              <TipMessage
                item={hoverItem}
                type={stopAction}
                taskType={taskType}
              />
            )
          }
          trigger='hover'
          onOpenChange={(visible) => {
            if (readonly) {
              return;
            }
            visible && getScheduleStopState();
          }}
        >
          <div
            onClick={() => {
              const scheduleDetailPermission = getPermissionById(
                PermissionButton.SPV_SCHEDULE_DETAIL,
              );
              if (!scheduleDetailPermission) {
                return;
              }
              setVisible(!visible);
            }}
          >
            <div className='plan-route'>
              <div
                className='actual-route'
                style={{ width: `${percent}%` }}
              ></div>
            </div>
            {travelStatus === 'START' && !readonly && (
              <ContinueTime
                departTimestamp={
                  stopList[currentIndex - 1]?.departTime ||
                  (findDepartTime && findDepartTime.departTime) ||
                  0
                }
                globalMileage={globalMileage}
                status={travelStatus}
              />
            )}

            <div className='dot'>
              <div className='dot-inner'>
                <img
                  src={stopAction && dotTypeImg.get(stopAction)?.[stopStatus]}
                ></img>
              </div>
            </div>
            <p className='tip'>{title}</p>
            {/* 倒计时 超时 */}
            {travelStatus === 'STAY' && !readonly && (
              <Time
                time={time}
                status={travelStatus}
                waitingTime={waitingTime}
                arrivedTime={arrivedTime}
                estDepartTime={estDepartTime}
              />
            )}
          </div>
        </Tooltip>
      </li>
      <ScheduleModel
        visible={visible}
        setVisibleCb={() => setVisible(!visible)}
        vehicleName={license}
      />
    </>
  );
};
export default React.memo(StopPoint);
